import { CalloutCard } from '../../components/visualizations/Cards';
import { Tooltip } from 'primereact/tooltip';
import { sendData } from './DataLoader';
import { useFetch } from './DataLoader';

        
// I want to use the FloatLabel component from primereact in the future but don't want to update to prevent breaking changes
// import { FloatLabel } from 'primereact/floatlabel'; 
        

// These constants can possibly be moved to a config file in the future
const COLOR_STATES = ['none', 'green', 'yellow', 'red']
export const DEFAULT_COLOR = {color:'border-gray-300 hover:border-gray-400', label: 'Not Rated'};
export const DEFAULT_COLOR_STYLE = {color: "#fff", border:'#a9bbcb', label: 'Not Rated'};
export const COLOR_CLASSES = {
    // none: {color:'border-gray-300 hover:border-gray-400', label: 'Not Rated'}, // Moved this to here instead of as a ternary in the QuestionCard component
    EXCEEDED: {
        color:'bg-green-200 border-green-400', 
        label: 'High Performer', 
        info: "Consistently exceeds expectations with strong initiative,\nreliability and contributes beyond assigned duties."
    },
    MET: {
        color:'bg-yellow-200 border-yellow-400', 
        label: 'Developing on Track', 
        info: "Meeting performance expectations and progressing steadily in role\nresponsibilities. Demonstrates growth, learning, and increasing consistency.\nShows initiative and openness to feedback while continuing to build skills and confidence."
    },
    MISSED: {
        color:'bg-red-200 border-red-400', 
        label: 'Needs Attention', 
        info: "Performance is below expectations.\nImprovement is needed to meet role requirements consistently."
    }
};

export const COLOR_STYLES = {
    EXCEEDED: {color: "#cddca4", border:'#a1bd54', label: 'High Performer'},
    MET: {color: "#ffeba3", border:'#ffd952', label: 'Developing on Track'},
    MISSED: {color: "#ffb9af", border:'#ff7c68', label: 'Needs Attention'}
}

export const SUPERUSER_INDEXES = [15118, 109, 128];

export const COMPETENCY_ORDER = [
    'PRODUCTIVITY',
    'TECHNICAL ABILITY/FIRM SYSTEMS',
    'CLIENT SERVICE',
    'PEOPLE DEVELOPMENT/TEAMWORK',
    'BUSINESS DEVELOPMENT'
]

export const onFormSubmitError = (errorData) => {
    // alert(JSON.stringify(errorData));
    console.log("errorData", errorData);
};

export const onFormSubmit = async (data, currentLevel, nextLevel, isSupervisorReview, apiToken) => {
    // alert(`Form submitted ${currentLevel} and ${nextLevel}`);
    data.current.level = currentLevel;
    data.next.level = nextLevel ? nextLevel : null;

    if (data.next.level === null ) {data.next = null}
    
    if (data) {
        console.log("submittingdata", data);
        const urlQuery = isSupervisorReview ? `?manager_index=${isSupervisorReview}` : '';
        const dataState = sendData(`/people/assessments/annual/competencies/responses${urlQuery}`, data, apiToken);
        console.log("dataState", dataState);
        return dataState;
    }
};


export const ColorLegend = () => {
    const legendKeys = Object.keys(COLOR_CLASSES);

    const LegendCard = ({color, label, index, info}) => {
        return (
            <div className="flex items-center justify-content-center" >
                <Tooltip target={`#legend-${index}`} content={`${info ? info : "No Rating Has Been Given"}`} tooltipOptions={{ position: 'bottom', mouseTrack: true, mouseTrackTop: 15 }}  />
                <div className={`w-11rem h-3rem border-2 ${color} rounded flex h-4rem items-center justify-center`} id={`legend-${index}`}>
                    <span style={{ alignSelf: 'center' }} className="text-lg font-medium w-full text-center" >{label}</span>
                </div>
            </div>
        )
    };
    return (
        <div className="mt-4 flex items-center justify-content-center text-sm w-full md:gap-4 lg:gap-8">
            {/* <span className="text-gray-600">Rating Legend:</span> */}
            <LegendCard color={DEFAULT_COLOR.color} label={DEFAULT_COLOR.label} index={0} />
            {legendKeys.map((colorKey, index)=><LegendCard 
                key={colorKey} 
                color={COLOR_CLASSES[colorKey].color} 
                label={COLOR_CLASSES[colorKey].label} 
                info={COLOR_CLASSES[colorKey].info}
                index={index+1} 
            />)}
        </div>
    )
};

export const WIPData = ({staffIndex}) => {
    const wipData = useFetch(`/user/metrics/wip/${staffIndex}?type=review`, [staffIndex]);
    return (
        <div className="flex justify-center items-center h-64 flex-row gap-2 w-full mt-4">
            <CalloutCard className={['review-metric-card']} value={!wipData.pending && wipData.data ? wipData.data.wiphours : 'Loading...'} title='Total Hours' color={null} />
            <CalloutCard className={['review-metric-card']} value={!wipData.pending && wipData.data ? wipData.data.billablehours : 'Loading...'} title='Chargeable Hours' color={null} />
            <CalloutCard className={['review-metric-card']} value={!wipData.pending && wipData.data ? wipData.data.bizdevhours : 'Loading...'} title='Business Development Hours' color={null} />
            <CalloutCard className={['review-metric-card']} value={!wipData.pending && wipData.data ? `${wipData.data.realization}%` : 'Loading...'} title='Realization' color={null} />
        </div>
    )
};

export const AssessmentInformationPanel = ({message="", submitted=false, selectStaff=false, className=""}) => {
    const submittedMessage = "This Annual Review Period's assessment has already been submitted.";
    const chooseStaffMessage = "Please select a staff to review.";
    return (
        <div className={`flex justify-center items-center h-64 flex-row gap-4 w-full mt-4 ${className}`}>
            <div className="text-gray-600">
                {message}
                {submitted === true && submittedMessage}
                {selectStaff === true && chooseStaffMessage}
            </div>
        </div>
    )
};

export const levelHeader = (level, levelTitle) => {
    return (
        <span className="text-xl font-semibold text-gray-800 mb-6 text-center w-6">      
            <span className="text-gray-600 font-light">{level === "current" ? "Current" : "Target"} Level: </span> 
            {levelTitle}
        </span>
    )
};